import React, { useState } from 'react';
import { Button, Icon, Input, Spin } from 'antd';
import { useSetIpPoolMapping } from 'mutation/domain';

export default function EditIPPoolCell({ data }) {
  const { mutateAsync, isLoading } = useSetIpPoolMapping({
    successMessage: 'IP Pool updated successfully.',
  });
  const [edit, setEdit] = useState(false);
  const [ipPool, setIpPool] = useState(data.ipPool);
  return (
    <Spin spinning={isLoading}>
      <div
        className="flex items-center space-x-2"
        style={{ justifyContent: 'center' }}
      >
        {edit && (
          <>
            <Input
              style={{ textAlign: 'right', width: 80 }}
              value={ipPool}
              onChange={e => setIpPool(e.target.value)}
            />
            <Icon
              style={{ fontSize: 22 }}
              theme="twoTone"
              twoToneColor="#52c41a"
              type="check-circle"
              onClick={() => {
                mutateAsync({ ...data, ipPool })
                  .then(() => setEdit(false))
                  .catch(() => {});
              }}
            />
            <Icon
              style={{ fontSize: 22 }}
              theme="twoTone"
              twoToneColor="#ff3333"
              type="close-circle"
              onClick={() => {
                setEdit(false);
                setIpPool(data.ipPool);
              }}
            />
          </>
        )}
        {!edit && (
          <>
            <p style={{ marginBottom: 0 }}>{data.ipPool || 'N/A'}</p>
            <Button icon="edit" onClick={() => setEdit(true)} />
          </>
        )}
      </div>
    </Spin>
  );
}
